// @flow

// types
import type { SelectedTariffs } from '../Types/QuoteType'
import type QuoteInstance from '../Controllers/QuoteInstance'

export const selectedTariffsSerializer = (selectedQuotes: { [productName: string]: QuoteInstance }, toArray: boolean = true): SelectedTariffs =>
  Object.keys(selectedQuotes).reduce((acc, productKey) => {
    if (selectedQuotes[productKey].subProductToTariffName[productKey]) {
      acc[productKey] = toArray
        ? [selectedQuotes[productKey].subProductToTariffName[productKey]]
        : selectedQuotes[productKey].subProductToTariffName[productKey]
    }
    return acc
  }, {})
